import React, { Component } from "react";
import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";
import SideBarInner from "../../../shared/sideBarInner";
import WinterMaintenceGroupsTools from "./WinterMaintenceGroupsTools";
import WinterMaintenceAreasTools from "./WinterMaintenceAreasTools";
import WinterMaintenceSensorsTools from "./WinterMaintenceSensorsTools";
import WinterMaintenceViewSwitcher from "./WinterMaintenceViewSwitcher";
import { states } from "../../../reducers/queriesStates";
import WinterMaintenceSearchTools from "./WinterMaintenceSearchTools";
import Preloader from "../../../shared/items/static/preloader";
import { withAuth } from "../../../shared/containers/containerAuth";
let intervalId = null;

class WinterMaintenceTools extends Component {
  componentDidMount() {
    const { winterAreasDataState, onGetWinterAreas, winterCompaniesRoutesDataState } = this.props;

    if (winterAreasDataState === states.NOT_REQUESTED || (intervalId === null && winterAreasDataState === states.READY)) {
      if (winterCompaniesRoutesDataState === states.NOT_REQUESTED) {
        onGetWinterAreas();
      }
    }

    const getWinterAreas = () => {
      const { winterAreasGetData, winterAreasDataState, winterCompaniesRoutesDataState } = this.props;

      if (
        winterAreasDataState === states.READY &&
        winterCompaniesRoutesDataState === states.NOT_REQUESTED &&
        (new Date() - winterAreasGetData) / 1000 > 60
      ) {
        onGetWinterAreas();
      }
    };

    intervalId = setInterval(getWinterAreas, 1000);
  }

  componentDidUpdate(prevProps) {
    const { winterCompaniesRoutesDataState } = this.props;

    if (winterCompaniesRoutesDataState !== states.NOT_REQUESTED) {
      clearInterval(intervalId);
      intervalId = null;
    }
  }

  componentWillUnmount() {
    clearInterval(intervalId);
    intervalId = null;
  }

  render() {
    const { winterAreas, winterAreasDataState } = this.props;

    if (winterAreasDataState === states.REQUEST && winterAreas.length === 0) {
      return (
        <div style={{ display: "flex", justifyContent: "center", paddingTop: "20px" }}>
          <Preloader />
        </div>
      );
    }

    return (
      <div>
        {winterAreas !== null && winterAreas.length > 0 ? (
          <div>
            <SideBarInner>
              <WinterMaintenceViewSwitcher />
            </SideBarInner>

            <SideBarInner>
              <WinterMaintenceSearchTools />
            </SideBarInner>
            <SideBarInner>
              <WinterMaintenceGroupsTools />
            </SideBarInner>

            <SideBarInner>
              <WinterMaintenceSensorsTools />
            </SideBarInner>

            <SideBarInner>
              {winterAreas.map((x) => {
                return <WinterMaintenceAreasTools key={x.id} winterArea={x} />;
              })}
            </SideBarInner>
          </div>
        ) : null}
      </div>
    );
  }
}

export default withAuth(withWinterMaintence(React.memo(WinterMaintenceTools)));
